<template>
  <p class="form-helper" :class="[brandClasses?.container, variant ? 'c-red-60' : 'c-red-30']">
    <vf-icon v-if="showIcon" :class="brandClasses?.icon" name="error" size="xs" />
    <slot />
  </p>
</template>

<script lang="ts" setup>
defineProps<{
  /**
   * Defines variant
   */
  variant?: 'inverse'
}>()

const { brandClasses, showIcon } = useAppConfig().components.vf.form?.error || {}
</script>
